import React, { Component } from "react";

export default class ContactUs extends Component {
  render() {
    return (
      <>
        <div class="contact_ul bg_light_red pt-5 pl-5 pr-5 pb-1 xpl_heading text-center">
          <h1>CONTACT US</h1>
        </div>
        <div
          class="contact_ul bg_light_red text-center"
          style={{ padding: "6px" }}
        >
          <ul style={{ padding: "15px" }}>
            <li>
              <h5 class="text-danger">
                Questions or feedback? We are here to assist you!
                <br />
                Reach out anytime—our team is ready to help.
              </h5>
            </li>
            <li>
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3506.1263324251026!2d77.0862461749521!3d28.505846589823275!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390d19451a7fc31d%3A0xbda28e726a11a616!2sXtra%20Power%20Tools%20(LSL%20Tools%20Private%20Limited)!5e0!3m2!1sen!2sin!4v1760613330078!5m2!1sen!2sin"
                width="600"
                height="450"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              />
            </li>
            <li>
              <h3
                style={{ lineHeight: "1", marginBottom: 0, marginTop: "2px" }}
              >
                LSL TOOLS PRIVATE LIMITED
              </h3>
              <br />
              <h3
                style={{ lineHeight: "0", marginBottom: 0, marginTop: "4px" }}
              >
                Regd. Office:
              </h3>{" "}
              <br />
              394, UDYOG VIHAR, PHASE III, GURUGRAM - 122016
              <br /> HARYANA, INDIA
              <br />
              CIN : U28100HR1995PTC088529,
            </li>
            <li>
              <h3
                style={{ lineHeight: "0", marginBottom: 0, marginTop: "28px" }}
              >
                Email:
              </h3>
              <br /> FOR ENQUIRY/REQUIREMENT:{" "}
              <a href="mailto:sales@xtrapowertools.com">
                sales@xtrapowertools.com
              </a>
              <br />
              FOR QUERY/FEEDBACK:{" "}
              <a href="mailto:care@xtrapowertools.com">
                care@xtrapowertools.com
              </a>
            </li>
            <li>
              <h3
                style={{ lineHeight: "1", marginBottom: 0, marginTop: "28px" }}
              >
                Contact Numbers:
              </h3>
            </li>
            <li>
              Customer Support (Queries, Complaints and general help):{" "}
              <a href="tel:+911244000608">+911244000608</a>,{" "}
              <a href="tel:+918743800144">+918743800144</a>
            </li>
            <li>Monday to Saturday - 9:30 AM to 6:30 PM</li>
          </ul>
        </div>
      </>
    );
  }
}
